import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
export default {
  name: "errLogs",
  data: function data() {
    return {
      option: {
        menu: false,
        addBtn: false,
        page: false,
        border: true,
        expand: true,
        refreshBtn: false,
        headerAlign: "center",
        column: [{
          label: "类型",
          prop: "type",
          width: 80,
          align: "center",
          slot: true,
          dicData: [{
            label: "bug",
            value: "error"
          }]
        }, {
          label: "地址",
          width: 200,
          prop: "url",
          overHidden: true
        }, {
          label: "内容",
          prop: "message",
          overHidden: true
        }, {
          label: "错误堆栈",
          prop: "stack",
          hide: true
        }, {
          label: "时间",
          align: "center",
          prop: "time",
          width: 200
        }]
      }
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  computed: _objectSpread({}, mapGetters(["logsList"])),
  props: [],
  methods: {
    send: function send() {
      var _this = this;

      this.$confirm("确定上传本地日志到服务器?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this.$store.dispatch("SendLogs").then(function () {
          _this.$parent.$parent.box = false;

          _this.$message({
            type: "success",
            message: "发送成功!"
          });
        });
      }).catch(function () {});
    },
    clear: function clear() {
      var _this2 = this;

      this.$confirm("确定清空本地日志记录?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        _this2.$store.commit("CLEAR_LOGS");

        window.console.log(_this2);
        _this2.$parent.$parent.box = false;

        _this2.$message({
          type: "success",
          message: "清空成功!"
        });
      }).catch(function () {});
    }
  }
};